export default "__VITE_ASSET__DC4$lQ8z__"